import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import CT from '@marketplace-ai/tags';
import React from 'react';

const TAGS = CT.documents.form;

interface Props {
  onClose: () => void;
  open: boolean;
  title?: string;
  children: React.ReactNode;
  xButton?: boolean;
  closeDisabled?: boolean;
}
export const ModalDialog = ({
  title,
  open,
  children,
  onClose,
  xButton,
  closeDisabled = false,
}: Props) => {
  const requestClose = () => {
    if (!closeDisabled) onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={requestClose}
      className="relative z-50"
      aria-label={title ? undefined : 'Dialog'}
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-grey-100/60 backdrop-blur-sm transition-opacity duration-0 data-closed:opacity-0 data-enter:not-data-closed:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-30 w-screen overflow-y-auto  max-w-[1200px] mx-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-xl bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all duration-0 data-closed:translate-y-4 data-closed:opacity-0 data-enter:not-data-closed:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95 max-h-[95vh] sm:max-h-[90vh] flex flex-col"
          >
            {xButton && (
              <div className="absolute right-0 top-0 p-4">
                <button
                  type="button"
                  onClick={requestClose}
                  disabled={closeDisabled}
                  className="rounded-full p-1.5 text-grey-400 hover:text-grey-100 hover:bg-grey-900 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
                >
                  <span className="sr-only">Close</span>
                  <XMarkIcon aria-hidden="true" className="size-5" />
                </button>
              </div>
            )}
            {title && (
              <div className="mt-3 sm:mt-5 pb-4 mb-4 border-b border-grey-900 text-center shrink-0">
                <DialogTitle data-cy={TAGS.title} className="sub-heading-sb text-grey-100">
                  {title}
                </DialogTitle>
              </div>
            )}
            <div className="pt-4 flex-1 min-h-0 overflow-y-auto">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
